import '@/assets/styles/base.scss';
import { BALL_PAGE_TYPE } from '../constants/pageType';
import { initBallPageType } from '../utils/pageType';
import { initPassportSDK } from '../utils/passport';

import App from './App-card-regular.svelte';

import { setupErrorMonitor } from '@/utils/errorMonitor';
import { reportP3, updateUid } from '@/utils/fmpTrack';
import { smallFlowInit } from '@/utils/smallFlow';

initBallPageType(BALL_PAGE_TYPE.REGULAR);
updateUid();
setupErrorMonitor();
window.isUseSlider = false;
initPassportSDK();

smallFlowInit();
reportP3();

const app = new App({
    target: document.getElementById('app')!
});

export default app;
